import * as React from 'react';
import { useCallback, useState } from 'react';
import { CurrentUserGq } from '../../graphql/users/models/CurrentUserGq';
import { SleekContext } from './SleekContext';

export interface SleekContextProviderProps {}

const SleekConSleekContextProvider: React.FC<SleekContextProviderProps> = ({ children }) => {
  const [sleekOpen, setSleekOpen] = useState<boolean>(false);

  // Wait 3 seconds until sleek is loaded for sure, then setup the triggers
  // This might actually still not work in some occassions (let's say sleek took forever to load, or the user clicks the button rather quickly)
  React.useEffect(() => {
    setTimeout(() => {
      (window as any)?.$sleek?.on('open', () => {
        setSleekOpen(true);
      });

      (window as any)?.$sleek?.on('close', () => {
        setSleekOpen(false);
      });
    }, 3000);
  }, []);

  const toggleSleek = useCallback(() => {
    (window as any)?.$sleek?.toggle();
  }, []);

  const openFeedback = useCallback(() => {
    (window as any)?.$sleek?.open('feedback.add');
  }, []);

  const setUser = useCallback((user: CurrentUserGq) => {
    if (!user) return;
    if (!(window as any)?.$sleek?.setUser) return;

    (window as any)?.$sleek?.setUser({
      mail: user.email,
      id: user.id,
      weight: 4,
    });
  }, []);

  return (
    <SleekContext.Provider value={{ sleekOpen, toggleSleek, setUser, openFeedback }}>
      {children}
    </SleekContext.Provider>
  );
};

export default SleekConSleekContextProvider;
